import { memo } from 'react';
import PropTypes from 'prop-types';
import UserAvatar from '../../userAvatar';

const User = ({ user }) => {
  return <UserAvatar variant="subtitle1" user={user} caption small />;
};

User.propTypes = {
  user: PropTypes.object.isRequired,
};

export default memo(User);
